import Glide from "@glidejs/glide"
import configByViewport from "./methods/configByViewport"
import configCaseCarousel from "./methods/configCaseCarousel"
import configPodcastCarousel from "./methods/configPodcastCarousel"
import configFeaturedGroups from "./methods/configFeaturedGroups"
import { onMounted, ref } from "vue"
import { useStore } from "vuex"
import SliderCardBasic from './cards/SliderCardBasic'
import ActivitySliderCard from './cards/ActivitySliderCard'
import PodcastSliderCard from 'components/PodcastSliderCard/PodcastSliderCard'
import CaseCard from "components/CaseCard/CaseCard"
import ReportCard from "components/ReportCard/ReportCard.vue"
import ThemeCard from "../ThemeCard/ThemeCard.vue"

const unifyCardHeight = function(root){
    root.value.querySelectorAll('.glide__slide').forEach(slide => {
        slide.style.height = `auto`
    })
}

export default {
    name: "ContentCarousel",
    components: { SliderCardBasic, ActivitySliderCard, PodcastSliderCard, CaseCard, ReportCard, ThemeCard},
    props:{
        glideBehaviour: {
            type: String,
            required: false,
            default: 'slider'
        },
        contentJson: {
            required: true
        },
        type: {
            type: String,
            required: false,
            default: 'news'
        },
        link: {
            type: Object,
            required: false
        },
        carouselId: {
            type: String,
            required: false
        }
    },
    setup(props) {
        const root = ref(null)
        const componentRootEl = ref(null)
        const glidePosition = ref(0)
        const sliderDOM = document.querySelector(`#${props.carouselId}`)
        let glide;

        const store = useStore()
        const getLabel = (labelKey)=> store.getters['labels/getLabel']({labelCollection: `contentCarousel-${props.carouselId}`, labelKey, emptyIfMissing: true})

        const displayProperties = {
            'news': {card: 'SliderCardBasic'},
            'activities': {card: 'ActivitySliderCard'},
            'cases': {card: 'CaseCard'},
            'podcasts': {card: 'PodcastSliderCard', perView: 4},
            'personalFundraisings': {card:'SliderCardBasic'},
            'reports': {card: 'ReportCard'},
            'groups': {card: 'ThemeCard'},
        }[props.type] ?? {card: 'SearchResultCard'}
        
        const configFunction = function () {
            const glideBehaviour = props.glideBehaviour
            const viewportSize = document.documentElement.clientWidth
            const perView = displayProperties.perView
            const carouselId = props.carouselId
            const numberOfCases = props.contentJson.length
            if (props.type === 'cases') {        
                return configCaseCarousel({glideBehaviour, carouselId, numberOfCases, startAt: glidePosition.value})
            } 

            if (props.type === 'podcasts') {        
                return configPodcastCarousel({glideBehaviour, carouselId, startAt: glidePosition.value})
            } 

            if (props.type === 'groups') {        
                return configFeaturedGroups({glideBehaviour, carouselId, startAt: glidePosition.value})
            } 

            return configByViewport({glideBehaviour, viewportSize, perView, startAt: glidePosition.value})
        }

        const truncateSummary = function (summary) {
            return summary.length > 120 ? summary.substring(0,117)+'...' : summary
        }

        function disableCarouselNavigation() {
            if (!(glide instanceof Glide)) {
                return false
            }
            const nextButton = sliderDOM.querySelector(
                '.kb-content-carousel__arrow[data-glide-dir=">"]'
            )
            const prevButton = sliderDOM.querySelector(
                '.kb-content-carousel__arrow[data-glide-dir="<"]'
            )
            const perView = glide.settings.perView
            const maxPosition = props.contentJson.length - perView

            const updateNavigationButtonDisabled = () => {
                if (glidePosition.value >= maxPosition) {
                    nextButton.disabled = true
                } else {
                    nextButton.removeAttribute('disabled')
                }
                if (glidePosition.value === 0) {
                    prevButton.disabled = true
                } else {
                    prevButton.removeAttribute('disabled')
                }
            }
            updateNavigationButtonDisabled()
        }

        onMounted(() => {
            unifyCardHeight(root)
            
            // proposed fix for the slider not working within ThemeSection M6
            // we wait until next frame

            setTimeout(() => {

                if (!sliderDOM) return

                glide = new Glide(sliderDOM, configFunction())
            
                glide.on('resize', function () {
                    glide.update(configFunction())
                })
            
                glide.mount()
                disableCarouselNavigation()
                glide.on('move', function (e) {
                    glidePosition.value = glide.index
                    disableCarouselNavigation()
                })
        
       
                document.querySelector('.glide').addEventListener('keydown', function(event) {
                    // When tab key is pressed
                    if (event.keyCode == 9) {
                        var card = event.target?.parentNode
                        if (card == null)
                            return

                        // Go to the next or previous card depending on whether it was a shift-tab
                        var nextCard = event.shiftKey ? card.previousSibling : card.nextSibling
                        var nextIndex = nextCard?.attributes["data-index"]?.value
                        if (nextIndex)
                            glide.go("="+nextIndex)
                    }
                })
            }, 200)
        })

        return {
            displayProperties,
            componentRootEl,
            getLabel,
            root,
            link: props.link,
            truncateSummary
        }
    }
}